<template>
  <v-container
    id="app-vouchers"
    class="pa-1"
  >
    <screen use-amount />

    <div class="bloc-action text-center">
      <v-card
        v-for="(voucher, i) in vouchers"
        :key="i"
        class="pa-3 mb-3"
      >
        <!-- ***** LIBELLE ***** -->
        <div
          v-ripple
          class="d-flex align-center"
          @click="openVoucher(i)"
        >
          <v-chip>
            {{ voucher.max }}
          </v-chip>
          <div class="ml-5">
            {{ voucher.title }}
          </div>
          <div class="ml-auto">
            <v-icon
              medium
              class="pt-1"
            >
              {{ voucher.show ? IconEnum.ch_down : IconEnum.ch_right }}
            </v-icon>
          </div>
        </div>
        <!-- ***** QUANTITY ***** -->
        <template v-if="voucher.show">
          <div class="d-flex">
            <div class="mx-auto">
              <counter
                v-model="voucher.quantity"
                :max="voucher.max"
                :min="0"
              />
            </div>
          </div>
          <v-btn
            color="success"
            class="bloc ml-0 mt-2"
            :disabled="voucher.quantity === 0"
            @click="useVoucher(i)"
          >
            {{ $t('field.loyalty.use') }}
          </v-btn>
        </template>
      </v-card>
    </div>

    <bottom-action
      btn-valid
      btn-cancel
      :btn-valid-disabled="!lockBack"
      :btn-del-disabled="lockBack"
      @valid="valid"
      @cancel="cancel"
      @del="del"
    />
  </v-container>
</template>

<script>
import Counter from '../../components/Counter'
import { Scan } from '@/modules/Scan'
import { IconEnum } from '@/modules/Enums'
import { $alert } from '@/modules/Utils'

export default {
  name: 'VouchersView',

  components: {
    Counter
  },

  props: {
    badge: { type: Object, required: true },
    carrier: { type: Object, default: null }
  },

  data () {
    return {
      IconEnum,
      //
      vouchers: [],
      ticket: null,
      lines: [],
      lockBack: false,
    }
  },

  beforeMount () {
    if (this.badge === undefined) {
      this.$router.replace('/')
    } else {
      this.$emit('title', this.$i18n.t('title.vouchers'))

      this.badge.LSTVCH.Vouchers.forEach(element => {
        this.vouchers.push({
          id: element.IDVch,
          title: element.Libelle,
          max: element.Nb,
          quantity: 0,
          show: false
        })
      })
    }
  },

  methods: {
    openVoucher (index) {
      for (let i = 0; i < this.vouchers.length; i++) {
        this.vouchers[i].show = (i === index)
      }
    },
    useVoucher (i) {
      Scan.launchVoucherConso(
        this.badge.IDBadge,
        this.vouchers[i].id,
        this.vouchers[i].quantity,
        (ticket) => {
          // Vérouillage retour badge info
          this.lockBack = true
          // Maj quantités
          this.vouchers[i].max -= this.vouchers[i].quantity
          this.vouchers[i].quantity = 0
          // Gestion du ticekt
          if (this.ticket !== null) {
            this.lines.push(this.ticket.Lignes[1])
          }
          this.ticket = ticket
          // Contrôle quantité du voucher restante
          if (this.vouchers[i].max === 0) {
            this.vouchers.splice(i, 1)
          }
          // Si plus aucun voucher, redirection directe vers ticket
          if (this.vouchers.length === 0) {
            this.valid()
          } else {
            $alert(this.$i18n.t('success.voucher_used'), 'success')
          }
        },
        (error) => {
          $alert(error)
        }
      )
    },
    // *** ACTION BUTTONS ***
    valid () {
      // Ajout des lignes enregistrées au dernier ticket
      if (this.lines.length > 0) {
        this.lines.forEach(line => {
          this.ticket.Lignes.splice(1, 0, line)
        })
      }
      this.$router.replace({
        name: 'ticket',
        params: { tickets: [this.ticket], carrier: this.carrier }
      })
    },
    del () {
      this.$emit('title', this.$i18n.t('title.info_badge'))
      this.$router.replace({
        name: 'info-badge',
        params: { badge: this.badge, carrier: this.carrier }
      })
    },
    cancel () {
      this.$router.replace('/home')
    }
  }
}
</script>
